module.exports = __webpack_public_path__ + "img/OMG.0556e5b9.svg";